import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudButtonModule, FreudCardModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { AppointmentTypeBadgeModule } from 'modules/appointments/components/appointment-type-badge/appointment-type-badge.module';
import { LottieModule } from 'ngx-lottie';

import { PromptuaryPendenciesComponent } from './promptuary-pendencies.component';

@NgModule({
	declarations: [PromptuaryPendenciesComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudButtonModule,
		LottieModule,
		FreudCardModule,
		AppointmentTypeBadgeModule,
	],
	exports: [PromptuaryPendenciesComponent],
	providers: [],
})
export class PromptuaryPendenciesModule {}
